import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function ArticlesSection() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-12 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-2">
              最新<strong className="text-primary-500">文章</strong>
            </h2>
            <p className="text-foreground-600 text-sm">精选优质内容，持续更新推送</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-200/50 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-background-50/90 text-foreground-700 rounded-full">
                    {article.tags[0]}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 mb-4 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" /> {article.readTime}
                  </span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}